import { NumToCharacters } from '../PricingStrategy/columns';
import Vue from 'vue';
import { httpPost } from '../../assets/scripts/http';

// 阶梯价方案
Vue.component('StepPlanGuidRender', {
  name: 'StepPlanGuidRender',
  render(h) {
    const { data, vm } = this.params;
    const renderCell = ele => {
      let val = ele;
      if (ele) {
        val = `方案${NumToCharacters(ele.StepPlanId)}`;
      }
      return h(
        'znl-button',
        {
          props: {
            type: 'text'
          },
          class: `${data.IsWholePackage ? 'line-through' : ''}`,
          on: {
            click() {
              if (data.IsWholePackage) {
                return null;
              }
              vm.currentTableRows = [data];
              vm.showSelectPricing = true;
            }
          }
        },
        val
      );
    };
    if (data.StepPlanGuid) {
      const StepPlan = vm.tieredPricingsNative.find(
        item => item.StepPlanGuid === data.StepPlanGuid
      );
      return renderCell(StepPlan);
    } else if (data.IsWholePackage) {
      return h('span', { style: { color: '#ccc' } }, '--');
    } else {
      return h(
        'znl-button',
        {
          props: { type: 'text' },
          on: {
            click() {
              vm.currentTableRows = [data];
              vm.showSelectPricing = true;
            }
          }
        },
        '<设置>'
      );
    }
  }
});

// 状态
Vue.component('StautsRender', {
  name: 'StautsRender',
  render(h) {
    const { data } = this.params;
    if (data.Stauts === 1) {
      return h('span', '展示中');
    } else {
      return h('span', [
        h('span', '异常'),
        h(
          'el-popover',
          {
            props: {
              placement: 'left-start',
              width: 200,
              trigger: 'hover',
              'popper-class': 'c-InventoryPricing-popover'
            }
          },
          [
            h('ul', [
              h('li', { class: 'title' }, '状态异常无法在管道销售'),
              !data.UntaxedPrice &&
                h('li', { class: 'li-row' }, '请填写未税价'),
              !!data.IsWholePackage &&
                !data.MPQQty &&
                h('li', { class: 'li-row' }, '整包请设置MPQ'),
              !data.StepPlanGuid &&
                !data.IsWholePackage &&
                h('li', { class: 'li-row' }, '请设置阶梯价方案'),
              data.TaxRate === null &&
                h('li', { class: 'li-row' }, '请设置是否可开票')
            ]),
            h('i', {
              class: 'icon-abnormal_ic iconfont',
              slot: 'reference'
            })
          ]
        )
      ]);
    }
  }
});

// 结算价
Vue.component('StandardPricesRender', {
  name: 'StandardPricesRender',
  render(h) {
    const { data, vm } = this.params;
    const that = this;
    const StepPlan = vm.tieredPricingsNative.find(
      item => item.StepPlanGuid === data.StepPlanGuid
    );
    return h(
      'el-popover',
      {
        props: {
          placement: 'left-start',
          width: 170,
          disabled: !data.StandardPrice,
          trigger: 'hover',
          'popper-class': 'c-InventoryPricing-popover finalprice'
        },
        on: {
          show() {
            if (data.IsWholePackage) {
              // 整包用标准价
              data.NewStepPrices = [
                {
                  Qty: data.MPQQty || 0,
                  Price: data.SettlementPrice
                }
              ];
            } else {
              // 自定义方案拉取最新阶梯售价
              httpPost('shareStock/getDevShareStockStepModelListAsync', {
                StandardPrice: data.SettlementPrice,
                StepPlanGuid: data.StepPlanGuid,
                IsInvoice: true
              }).then(res => {
                if (res.Code === 0) {
                  data.NewStepPrices = res.Data;
                  // 价格小于20的数据
                  data.NewStepPricesLessThan20 = StepPlan.StepPlanPrices.sort(
                    (a, b) => {
                      return a.Qty - b.Qty;
                    }
                  ).filter(item => {
                    // 取 阶梯价数量 * 倍率 * 含税价
                    return (
                      item.Qty * item.PriceMultiple * data.StandardPrice < 20
                    );
                  });
                }
              });
            }
          }
        }
      },
      [
        h('ul', [
          h('li', { class: 'title final-price' }, '最终售价'),
          !data.IsWholePackage &&
            h('li', { class: 'tip' }, StepPlan ? StepPlan.StepPlanSummary : ''),
          data.IsWholePackage &&
            h('li', { class: 'tip' }, '整包售价阶梯价方案不可用'),
          // 价格小于20的方案
          !data.IsWholePackage &&
            !!data.NewStepPricesLessThan20 &&
            data.NewStepPricesLessThan20.length > 0 &&
            h(
              'li',
              { class: 'LessThan20' },
              data.NewStepPricesLessThan20.map(item => {
                return h(
                  'div',
                  {
                    class: `final-price`
                  },
                  [
                    h('span', { class: 'row-span' }, `${item.Qty}+`),
                    h(
                      'span',
                      { class: 'row-span' },
                      `¥${Math.round(
                        item.PriceMultiple * data.SettlementPrice * 10000 // 倍率 * 结算价
                      ) / 10000}`
                    )
                  ]
                );
              })
            ),
          // 自定义方案拉取最新阶梯售价
          data.NewStepPrices
            ? data.NewStepPrices.map(item => {
                return h(
                  'li',
                  {
                    class: `final-price`
                  },
                  [
                    h(
                      'span',
                      { class: 'row-span' },
                      `${item.Qty}${data.IsWholePackage ? '' : '+'}`
                    ),
                    h('span', { class: 'row-span' }, `¥${item.Price}`)
                  ]
                );
              })
            : '',
          !!data.NewStepPricesLessThan20 &&
            data.NewStepPricesLessThan20.length > 0 &&
            h('li', { class: 'tip' }, '*为避免订单金额过低,系统将优化起订量')
        ]),
        h(
          'span',
          {
            slot: 'reference',
            class: 'smart-solution',
            on: {
              click() {
                that.params.api.setFocusedCell(
                  that.params.rowIndex,
                  that.params.column.colId
                );
                that.params.api.startEditingCell({
                  rowIndex: that.params.rowIndex,
                  colKey: that.params.column.colId
                });
              }
            }
          },
          [
            h('span', data.SettlementPrice ? `¥${data.SettlementPrice}` : `--`),
            h('i', {
              class: 'iconfont icon-show_btn'
            })
          ]
        )
      ]
    );
  }
});

// 整包、开票
Vue.component('CheckedBoxRender', {
  name: 'CheckedBoxRender',
  render(h) {
    const { data, updateRowData, field } = this.params;
    let text = '';
    switch (field) {
      case 'IsWholePackage':
        text = '整包';
        break;
    }
    return h('div', [
      h(
        'el-checkbox',
        {
          props: {
            value: data[field]
          },
          on: {
            input(value) {
              data[field] = value;
              updateRowData(data);
            }
          }
        },
        text
      )
    ]);
  }
});

Vue.component('GridHeaderSortRender', {
  render(h) {
    const { vm, field } = this.params;

    return h(
      'span',
      {
        class: 'header-mpq',
        on: {
          click() {
            if (
              new RegExp(
                field === 'MPQQty' ? 'StandardPrice' : 'MPQQty',
                'gi'
              ).test(vm.OrderBy)
            ) {
              vm.OrderBy = '';
            }
            if (!vm.OrderBy) {
              vm.OrderBy = `${field} desc`;
            } else if (vm.OrderBy === `${field} desc`) {
              vm.OrderBy = `${field} asc`;
            } else if (vm.OrderBy === `${field} asc`) {
              vm.OrderBy = '';
            }
            vm.onBindData();
          }
        }
      },
      [
        h(
          'span',
          {
            class: 'header-mpq-title'
          },
          field === 'MPQQty' ? 'MPQ' : field === 'StandardPrice' ? '未税价' : ''
        ),
        h(
          'span',
          {
            class: 'header-mpq-icon'
          },
          [
            h('i', {
              class: `iconfont icon-up ${
                vm.OrderBy === `${field} asc` ? 'active' : ''
              } `
            }),
            h('i', {
              class: `iconfont icon-xiala ${
                vm.OrderBy === `${field} desc` ? 'active' : ''
              } `
            })
          ]
        )
      ]
    );
  }
});
